<template>
  <div>
    <Header />
    <div class="dovemed-container">
      <div v-if="isLoading" class="loader-bg">
        <div class="loader-container">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="dovemed-wrapper text-center signup-page">
        <div class="signup-container" v-if="!isLoading">
          <h2 class="hyper-link mb-4 pt-5">{{ message }}</h2>
          <a-button
            v-if="!isError"
            @click="$router.push('/circles')"
            :style="{ background: getPrimaryFallbackColor() }"
            class="dovemed-button font-white ml-4 primary-button"
            >LOGIN TO CONTINUE
          </a-button>
          <a-button
            v-if="isError"
            @click="() => $refs.emailVerifyModal.show()"
            :style="{ background: getPrimaryFallbackColor() }"
            class="dovemed-button font-white ml-4 primary-button"
            >RESEND VERIFICATION EMAIL
          </a-button>
        </div>
      </div>
      <EmailVerifyModal ref="emailVerifyModal" />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../App/HeaderGeneric";
import Footer from "../App/FooterGeneric";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import EmailVerifyModal from "../Modals/EmailVerification";

const UserRepository = RepositoryFactory.get("user");

export default {
  name: "EmailVerify",
  components: {
    Header,
    Footer,
    EmailVerifyModal,
  },
  data() {
    return {
      type: null,
      id: null,
      message: "",
      isError: false,
    };
  },

  created() {
    console.warn('home/EmailVerification.vue is created');
    this.type = this.$route.params.type;
    this.id = this.$route.params.id;
    this.setAppLoaderStatus(true);
    this.verify();
  },

  methods: {
    verify() {
      UserRepository.verifyEmail(this.type, this.id)
        .then((res) => {
          this.setAppLoaderStatus(false);
          this.message = "Verified Successfully";
          // this.$router.push({ name: 'Login' })
        })
        .catch((err) => {
          this.isError = true;
          this.setAppLoaderStatus(false);
          this.message = err.response.data.message;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/EmailVerification.vue